import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
  
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  WhatsappIcon,
  EmailIcon,
} from 'react-share';
import { renderText } from '../hooks/TextVeiw';

const ShareMeal = ({ url, title, description }) => {
    const desc = renderText(description)
  return (
    <div className="share-container">
      <h3 className='text-sm font-kufi text-gray-600 dark:text-gray-300 mb-2'>شارك هذه الوجبه </h3>
      
      <div className=" gap-2 flex flex-row ">
        <FacebookShareButton 
          url={url}
          quote={title}
          hashtag="#وجبة"
          className=""
      
          
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        
        <TwitterShareButton
          url={url}
          title={title}
          via="yourTwitterHandle"
          hashtags={["مقال", ""]}
          className="share-button"
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        
        <TelegramShareButton
          url={url}
          title={title}
          className="share-button"
        >
          <TelegramIcon size={32} round />
        </TelegramShareButton>
        
        <WhatsappShareButton
          url={url}
          title={title}
          separator=" :: "
          className="share-button"
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        
        <EmailShareButton
          url={url}
          subject={title}
          body={desc}
          className="share-button"
        >
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>
    </div>
  );
};

export default ShareMeal;